import { createInertiaApp } from '@inertiajs/react'
import { createRoot } from 'react-dom/client'
import type { ComponentType, ReactNode } from 'react'
import axios from 'axios'
import AppLayout from '../layouts/AppLayout'
import '../styles/application.css'

// Rails' forgery protection validates the X-CSRF-Token header. Inertia uses the
// default axios instance; point it at the XSRF-TOKEN cookie set by
// Web::Base#set_csrf_cookie and send it under the header Rails expects.
axios.defaults.xsrfCookieName = 'XSRF-TOKEN'
axios.defaults.xsrfHeaderName = 'X-CSRF-Token'

type PageModule = { default: ComponentType & { layout?: (page: ReactNode) => ReactNode } }

createInertiaApp({
  // A page's <Head title> wins; a page without one keeps the app name. Without
  // this fallback Inertia would drop the layout's <title inertia> on pages that
  // render no <Head title>, leaving the tab with only the URL.
  title: (title) => title || '番茄钟应用',
  // Resolve page components from app/frontend/pages/**, wrapping each in the
  // app shell (Header/Footer) by default — mirrors the old Next.js root layout.
  resolve: (name) => {
    const pages = import.meta.glob<PageModule>('../pages/**/*.tsx', { eager: true })
    const page = pages[`../pages/${name}.tsx`]
    if (!page) {
      throw new Error(`Inertia page not found: ${name} (app/frontend/pages/${name}.tsx)`)
    }
    page.default.layout ??= (p: ReactNode) => <AppLayout>{p}</AppLayout>
    return page
  },
  setup({ el, App, props }) {
    createRoot(el).render(<App {...props} />)
  },
})
